"use client"

import { Suspense, lazy, useState } from "react"

const AccountTab = lazy(() => import("./tabs/AccountTab"))
// const SecurityTab = lazy(() => import("./tabs/SecurityTab"))
// const BillingTab = lazy(() => import("./tabs/BillingTab"))
const SubscriptionTab = lazy(() => import("./tabs/SubscriptionTab"))
// const LogsTab = lazy(() => import("./tabs/LogsTab"))
// const DevicesTab = lazy(() => import("./tabs/DevicesTab"))

// SVG Icons
const UserIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
)

// const LockIcon = () => (
//   <svg
//     width="18"
//     height="18"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
//     <path d="M7 11V7a5 5 0 0 1 10 0v4" />
//   </svg>
// )

// const CreditCardIcon = () => (
//   <svg
//     width="18"
//     height="18"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
//     <line x1="1" y1="10" x2="23" y2="10" />
//   </svg>
// )

const StarIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
)

// const ClipboardIcon = () => (
//   <svg
//     width="18"
//     height="18"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
//     <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
//   </svg>
// )

// const DeviceIcon = () => (
//   <svg
//     width="18"
//     height="18"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
//     <line x1="12" y1="18" x2="12.01" y2="18" />
//   </svg>
// )

const SettingsIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
)

export default function AccountSettings() {
  const [activeTab, setActiveTab] = useState("account")

  const tabs = [
    { key: "account", label: "Account", icon: <UserIcon />, component: <AccountTab /> },
    // { key: "security", label: "Security", icon: <LockIcon />, component: <SecurityTab /> },
    // { key: "billing", label: "Billing", icon: <CreditCardIcon />, component: <BillingTab /> },
    { key: "subscription", label: "Subscription", icon: <StarIcon />, component: <SubscriptionTab /> },
    // { key: "logs", label: "Activity Logs", icon: <ClipboardIcon />, component: <LogsTab /> },
    // { key: "devices", label: "Devices", icon: <DeviceIcon />, component: <DevicesTab /> },
  ]

  return (
    <>
      <style>{`
        .settings-container {
          padding: 2rem 0;
          min-height: 100vh;
          background: #f1f5f9;
        }
        
        .settings-header {
          display: flex;
          align-items: center;
          gap: 1rem;
          padding: 1.5rem 2rem;
          border-bottom: 1px solid #e2e8f0;
        }
        
        .settings-header-icon {
          width: 48px;
          height: 48px;
          background: #eff6ff;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #2563eb;
        }
        
        .settings-header-text h2 {
          margin: 0;
          font-weight: 700;
          font-size: 1.5rem;
          color: #0f172a;
        }
        
        .settings-header-text p {
          margin: 0.25rem 0 0 0;
          color: #64748b;
          font-size: 0.9rem;
        }
        
        .settings-card {
          background: white;
          border-radius: 12px;
          border: 1px solid #e2e8f0;
          overflow: hidden;
        }
        
        .settings-tabs {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          padding: 1rem 1.5rem;
          background: #f8fafc;
          border-bottom: 1px solid #e2e8f0;
        }
        
        .settings-tab {
          background: white;
          border: 1px solid #e2e8f0;
          color: #64748b;
          padding: 0.625rem 1rem;
          border-radius: 8px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.875rem;
        }
        
        .settings-tab:hover {
          background: #f8fafc;
          border-color: #2563eb;
          color: #2563eb;
        }
        
        .settings-tab.active {
          background: #2563eb;
          border-color: #2563eb;
          color: white;
        }
        
        .settings-tab-icon {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .settings-content {
          padding: 2rem;
          min-height: 400px;
        }
        
        .settings-loading {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 4rem 2rem;
        }
        
        .settings-loading-card {
          width: 100%;
          max-width: 600px;
        }
        
        .settings-skeleton {
          background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
          border-radius: 6px;
        }
        
        .settings-skeleton-header {
          height: 24px;
          width: 40%;
          margin-bottom: 1.5rem;
        }
        
        .settings-skeleton-row {
          display: flex;
          gap: 1rem;
          margin-bottom: 1rem;
        }
        
        .settings-skeleton-label {
          height: 16px;
          width: 100px;
        }
        
        .settings-skeleton-input {
          height: 40px;
          flex: 1;
        }
        
        @keyframes shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
        
        @media (max-width: 768px) {
          .settings-tabs {
            gap: 0.375rem;
            padding: 0.75rem 1rem;
          }
          
          .settings-tab {
            padding: 0.5rem 0.75rem;
            font-size: 0.8rem;
          }
          
          .settings-tab span:last-child {
            display: none;
          }
          
          .settings-content {
            padding: 1.25rem;
          }
          
          .settings-header {
            padding: 1.25rem 1.5rem;
          }
          
          .settings-header-text h2 {
            font-size: 1.25rem;
          }
        }
      `}</style>

      <div className="settings-container">
        <div className="container">
          <div className="settings-card">
            <div className="settings-header">
              <div className="settings-header-icon">
                <SettingsIcon />
              </div>
              <div className="settings-header-text">
                <h2>Account Settings</h2>
                <p>Manage your account preferences and security settings</p>
              </div>
            </div>

            <div className="settings-tabs">
              {tabs.map((tab) => (
                <button
                  key={tab.key}
                  className={`settings-tab ${activeTab === tab.key ? "active" : ""}`}
                  onClick={() => setActiveTab(tab.key)}
                >
                  <span className="settings-tab-icon">{tab.icon}</span>
                  <span>{tab.label}</span>
                </button>
              ))}
            </div>

            <div className="settings-content">
              <Suspense
                fallback={
                  <div className="settings-loading">
                    <div className="settings-loading-card">
                      <div className="settings-skeleton settings-skeleton-header"></div>
                      <div className="settings-skeleton-row">
                        <div className="settings-skeleton settings-skeleton-label"></div>
                        <div className="settings-skeleton settings-skeleton-input"></div>
                      </div>
                      <div className="settings-skeleton-row">
                        <div className="settings-skeleton settings-skeleton-label"></div>
                        <div className="settings-skeleton settings-skeleton-input"></div>
                      </div>
                      <div className="settings-skeleton-row">
                        <div className="settings-skeleton settings-skeleton-label"></div>
                        <div className="settings-skeleton settings-skeleton-input"></div>
                      </div>
                    </div>
                  </div>
                }
              >
                {tabs.find((t) => t.key === activeTab)?.component}
              </Suspense>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
